export const contactDetails = {
    name: "Chaitanya Bharat",
    email: "chaitanyadokara@gmail.com",
    phone: "+91 8008385658",
    location: "Hyderabad, India",
    role:"Python Backend Developer",
    experience:"4 Years",
    fullName:"Chaitanya Bharat Dokara",
    photo:"https://chaitanya-website-portfolio.s3.eu-north-1.amazonaws.com/chaitu_pic.jpg",
    completeBio:"I have completed my B.tech in GITAM University with 8.22 GPA. I started my career as a Content Developer at IBHubs from 2020. Here I have worked in creating problem statements, hints and solutions in python language also during that period I also worked as Python Backend Developer using Django framework and created REST APIs for projects and also then created functionality tests using Pytest and did API tests using Postman. Iam also a certified Cloud Practitioner. I have Built full stack web applications using ReactJS, Bootstrap, Tailwind and Django frameworks.  I also built mobile applications using Flutter. After I have worked as a Flutter App Developer with Riverpod state management. For a small duration I worked as Quality Tester for Content Translation."

  }

export const socialLinks = {
    github: "https://github.com/dchaitu",
    linkedin: "https://www.linkedin.com/in/chaitanyadokara/",
    upwork:"https://www.upwork.com/freelancers/~01f76aafa40382d3b3"
}

export const aboutDetails = {
    aboutMe:"Hello! I'm a Python Backend Developer with a passion for creating beautiful and functional web applications. I specialize in React.js and modern JavaScript frameworks, and I love turning ideas into reality through code."

}

export const subheading = "A passionate developer with experience in various technologies and frameworks"

export const projects = [
    {
        id: 1,
        title: 'Slack clone App',
        description: 'A chat application to help users to create rooms and chat with their friends. It includes messaging, replying, reacting with emojis file transferring, requesting users to join a room. And Admin allowing users to join the room and removing users from the room.',
        technologies: ['React JS', 'Fast API', 'REST API','AWS'],
        image: '/images/chat.png',
        link:"https://chat.chaitanyadokara.in/",
    },
    {
        id: 2,
        title: 'Forms clone App',
        description: 'Form clone app helps in creating forms for users sections questions, selecting different types of questions and storing responses and returning the responses in csv.',
        technologies: ['React JS', 'Fast API', 'REST API','AWS'],
        image: '/images/forms.png',
        link:"https://forms.chaitanyadokara.in/",
    },
    {
      id: 3,
      title: 'Ants vs Bees',
      description: 'As the ant queen, you populate your colony with the bravest ants you can muster. Your ants must protect their queen from the evil bees that invade your territory. Irritate the bees enough by throwing leaves at them, and they will be vanquished. Fail to pester the airborne intruders adequately, and your queen will succumb to the bees wrath',
      technologies: ['Flutter', 'Dart', 'Riverpod'],
      image: '/images/ants_bees.png',
      link:"https://game.chaitanyadokara.in/",
    },
    {
      id: 4,
      title: 'Task Management App',
      description: 'A task management application to help users organize their daily tasks and increase productivity.',
      technologies: ['React', 'Django', 'REST API','AWS'],
      image: '/images/tasks.png',
      link:"https://tasks.chaitanyadokara.in/",
    },
    {
      id: 5,
      title: 'Wordle',
      description: 'A word-guessing game where players try to guess a hidden word in a limited number of attempts.',
      technologies: ['Flutter', 'Dart', 'Riverpod', "AWS","DynamoDB"],
      image: '/images/wordle.png',
      link:"https://wordle.chaitanyadokara.in/",
    },

  ];


export const programming_languages = [
    "Python","C++","SQL",
]

export const web_development = ["HTML","CSS","Bootstrap","Tailwind","JavaScript","ReactJS"]

export const mobile_development = ["Flutter","Dart","Riverpod"]

export const backend_development = ["Django","Django Rest Framework","Flask","FastAPI"]

export const cloud_services = ["AWS"]

export const no_code = ["Framer","Webflow"]


export const skills = [
  {name:"Programming Languages",technologies:programming_languages},
  {name:"Web Development",technologies:web_development},
  {name:"Mobile Development",technologies:mobile_development},
  {name:"Backend Development",technologies:backend_development},
  {name:"Cloud Services",technologies:cloud_services},
  {name:"No Code",technologies:no_code},

];

export const siteKey = "6Lcp4Y0rAAAAAD_kq7y5aB5QlfGM5QLlbxywSlBu";
export const secretKey = "6Lcp4Y0rAAAAAMx574CaTgPELQT7aT24Aprreo84";
